import { BaseAddress, IBaseAddress } from "@/types/BaseAddress";

export interface IPolicy extends IBaseAddress {
  policy_id: string;
  risk_id: number;
  material_damage: number;
  business_interruption: string;
  theft: number;
  total_sum_insured: number;
  fire_station_distance_km: number;
  flood_rank: number;
  theft_rank: number;
  burglary_rank: number;
  policy_risk_id: string;
}

export class Policy extends BaseAddress {
  get policyId(): string {
    return "policy_id" in this._data ? this._data.policy_id : "";
  }

  get riskId(): number | null {
    return "risk_id" in this._data ? this._data.risk_id : null;
  }

  get policyRiskId(): string {
    return "policy_risk_id" in this._data && this._data.policy_risk_id
      ? this._data.policy_risk_id
      : this.policyId && this.riskId
      ? `${this.policyId}#${this.riskId}`
      : "";
  }

  get materialDamage(): number {
    return "material_damage" in this._data ? this._data.material_damage : 0;
  }

  get businessInterruption(): string {
    return "business_interruption" in this._data
      ? this._data.business_interruption
      : "";
  }

  get theft(): number {
    return "theft" in this._data ? this._data.theft : 0;
  }

  get totalSumInsured(): number {
    return "total_sum_insured" in this._data ? this._data.total_sum_insured : 0;
  }

  get fireStationDistanceKm(): number | undefined {
    return "fire_station_distance_km" in this._data
      ? this._data.fire_station_distance_km
      : undefined;
  }

  get floodRank(): number | undefined {
    return "flood_rank" in this._data ? this._data.flood_rank : undefined;
  }

  get theftRank(): number | undefined {
    return "theft_rank" in this._data ? this._data.theft_rank : undefined;
  }

  get burglaryRank(): number | undefined {
    return "burglary_rank" in this._data ? this._data.burglary_rank : undefined;
  }
}
